import { Link } from "react-router-dom";
import { Send, Phone, MapPin, Mail } from "lucide-react";
import { doctor } from "../lib/data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-bone mt-24 md:mt-32"
    >
      <div className="container-luxe py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-4xl md:text-5xl leading-none">
            Tetiana<br />Zolotko
          </div>
          <p className="mt-6 text-sm text-bone/60 max-w-sm leading-relaxed">
            Лікар терапевт-косметолог. Преміальний підхід до краси,
            wellness та anti-age медицини.
          </p>
          <Link
            to="/booking"
            data-testid="footer-book-cta"
            className="inline-flex items-center mt-8 rounded-full bg-bone text-ink px-6 py-3 text-[11px] tracking-[0.25em] uppercase hover:bg-nude transition"
          >
            Онлайн запис
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-bone/40 mb-4">Навігація</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-bone text-bone/70">Про мене</Link></li>
            <li><Link to="/services" className="hover:text-bone text-bone/70">Послуги</Link></li>
            <li><Link to="/academy" className="hover:text-bone text-bone/70">Навчання</Link></li>
            <li><Link to="/certificates" className="hover:text-bone text-bone/70">Сертифікати</Link></li>
            <li><Link to="/blog" className="hover:text-bone text-bone/70">Блог</Link></li>
            <li><Link to="/contacts" className="hover:text-bone text-bone/70">Контакти</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-bone/40 mb-4">Контакти</div>
          <ul className="space-y-3 text-sm text-bone/80">
            <li className="flex items-start gap-3">
              <Phone size={16} strokeWidth={1.5} className="mt-0.5 text-bone/40" />
              <div className="flex flex-col">
                {doctor.phones.map((p, i) => (
                  <a key={p} data-testid={`footer-phone-${i}`} href={`tel:${doctor.phonesRaw[i]}`} className="hover:text-bone">
                    {p}
                  </a>
                ))}
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} strokeWidth={1.5} className="mt-0.5 text-bone/40" />
              <a data-testid="footer-email" href={`mailto:${doctor.email}`} className="hover:text-bone break-all">
                {doctor.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-bone/40" />
              <span>{doctor.address}</span>
            </li>
            <li className="flex items-center gap-4 pt-3">
              <a
                data-testid="footer-telegram"
                href={doctor.telegram}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-bone/70 hover:text-bone"
              >
                <Send size={16} strokeWidth={1.5} /> Telegram
              </a>
              <a
                data-testid="footer-maps"
                href={doctor.mapsLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-bone/70 hover:text-bone"
              >
                <MapPin size={16} strokeWidth={1.5} /> Маршрут
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-bone/10">
        <div className="container-luxe py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-bone/40">
          <div>© {new Date().getFullYear()} Tetiana Zolotko Clinic. Всі права захищені.</div>
          <div className="tracking-[0.25em] uppercase">Premium Aesthetic Medicine</div>
        </div>
      </div>
    </footer>
  );
}
